export default "__VITE_ASSET__D0bym6CR__"